import { Country, State } from '../model/user.model';

export const COUNTRIES: Country[] = [
  { name: 'Afganistán', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Argelia', code: 'DZ' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Antigua y Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaiyán', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahréin', code: 'BH' },
  { name: 'Bangladés', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarús', code: 'BY' },
  { name: 'Bélgica', code: 'BE' },
  { name: 'Belice', code: 'BZ' },
  { name: 'Benín', code: 'BJ' },
  { name: 'Bután', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia y Herzegovina', code: 'BA' },
  { name: 'Botsuana', code: 'BW' },
  { name: 'Brasil', code: 'BR' },
  { name: 'Brunéi', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cabo Verde', code: 'CV' },
  { name: 'Camboya', code: 'KH' },
  { name: 'Camerún', code: 'CM' },
  { name: 'Canadá', code: 'CA' },
  { name: 'República Centroafricana', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoras', code: 'KM' },
  { name: 'Congo (Congo-Brazzaville)', code: 'CG' },
  { name: 'Congo (República Democrática del)', code: 'CD' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croacia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Chipre', code: 'CY' },
  { name: 'República Checa', code: 'CZ' },
  { name: 'Dinamarca', code: 'DK' },
  { name: 'Yibuti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'República Dominicana', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egipto', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Guinea Ecuatorial', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'España', code: 'ES' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Esuatini', code: 'SZ' },
  { name: 'Etiopía', code: 'ET' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finlandia', code: 'FI' },
  { name: 'Francia', code: 'FR' },
  { name: 'Gabón', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Alemania', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Grecia', code: 'GR' },
  { name: 'Granada', code: 'GD' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bisau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haití', code: 'HT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hungría', code: 'HU' },
  { name: 'Islandia', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Irán', code: 'IR' },
  { name: 'Irak', code: 'IQ' },
  { name: 'Irlanda', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italia', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japón', code: 'JP' },
  { name: 'Jordania', code: 'JO' },
  { name: 'Kazajistán', code: 'KZ' },
  { name: 'Kenia', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kirguistán', code: 'KG' },
  { name: 'Laos', code: 'LA' },
  { name: 'Letonia', code: 'LV' },
  { name: 'Líbano', code: 'LB' },
  { name: 'Lesoto', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libia', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lituania', code: 'LT' },
  { name: 'Luxemburgo', code: 'LU' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malasia', code: 'MY' },
  { name: 'Maldivas', code: 'MV' },
  { name: 'Malí', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Islas Marshall', code: 'MH' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauricio', code: 'MU' },
  { name: 'México', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldavia', code: 'MD' },
  { name: 'Mónaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Marruecos', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Birmania (Myanmar)', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Países Bajos', code: 'NL' },
  { name: 'Nueva Zelanda', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Níger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Corea del Norte', code: 'KP' },
  { name: 'Macedonia del Norte', code: 'MK' },
  { name: 'Noruega', code: 'NO' },
  { name: 'Omán', code: 'OM' },
  { name: 'Pakistán', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Estado de Palestina', code: 'PS' },
  { name: 'Panamá', code: 'PA' },
  { name: 'Papúa Nueva Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Perú', code: 'PE' },
  { name: 'Filipinas', code: 'PH' },
  { name: 'Polonia', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Catar', code: 'QA' },
  { name: 'Rumania', code: 'RO' },
  { name: 'Rusia', code: 'RU' },
  { name: 'Ruanda', code: 'RW' },
  { name: 'San Cristóbal y Nieves', code: 'KN' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Santa Lucía', code: 'LC' },
  { name: 'San Vicente y las Granadinas', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'Sao Tomé y Príncipe', code: 'ST' },
  { name: 'Arabia Saudita', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leona', code: 'SL' },
  { name: 'Singapur', code: 'SG' },
  { name: 'Eslovaquia', code: 'SK' },
  { name: 'Eslovenia', code: 'SI' },
  { name: 'Islas Salomón', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'Sudáfrica', code: 'ZA' },
  { name: 'Corea del Sur', code: 'KR' },
  { name: 'Sudán del Sur', code: 'SS' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudán', code: 'SD' },
  { name: 'Surinam', code: 'SR' },
  { name: 'Suecia', code: 'SE' },
  { name: 'Suiza', code: 'CH' },
  { name: 'Siria', code: 'SY' },
  { name: 'Taiwán', code: 'TW' },
  { name: 'Tayikistán', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Tailandia', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad y Tobago', code: 'TT' },
  { name: 'Túnez', code: 'TN' },
  { name: 'Turquía', code: 'TR' },
  { name: 'Turkmenistán', code: 'TM' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ucrania', code: 'UA' },
  { name: 'Emiratos Árabes Unidos', code: 'AE' },
  { name: 'Reino Unido', code: 'GB' },
  { name: 'Estados Unidos', code: 'US' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistán', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Vaticano', code: 'VA' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabue', code: 'ZW' }
];

export const STATES: State[] = [
  { name: 'Alicante', code: 'A' },
  { name: 'Albacete', code: 'AB' },
  { name: 'Almería', code: 'AL' },
  { name: 'Ávila', code: 'AV' },
  { name: 'Barcelona', code: 'B' },
  { name: 'Badajoz', code: 'BA' },
  { name: 'Vizcaya', code: 'BI' },
  { name: 'Burgos', code: 'BU' },
  { name: 'La Coruña', code: 'C' },
  { name: 'Cádiz', code: 'CA' },
  { name: 'Cáceres', code: 'CC' },
  { name: 'Ceuta', code: 'CE' },
  { name: 'Córdoba', code: 'CO' },
  { name: 'Ciudad Real', code: 'CR' },
  { name: 'Castellón', code: 'CS' },
  { name: 'Cuenca', code: 'CU' },
  { name: 'Las Palmas', code: 'GC' },
  { name: 'Gerona', code: 'GI' },
  { name: 'Granada', code: 'GR' },
  { name: 'Guadalajara', code: 'GU' },
  { name: 'Huelva', code: 'H' },
  { name: 'Huesca', code: 'HU' },
  { name: 'Jaén', code: 'J' },
  { name: 'Lérida', code: 'L' },
  { name: 'León', code: 'LE' },
  { name: 'La Rioja', code: 'LO' },
  { name: 'Lugo', code: 'LU' },
  { name: 'Madrid', code: 'M' },
  { name: 'Málaga', code: 'MA' },
  { name: 'Melilla', code: 'ML' },
  { name: 'Murcia', code: 'MU' },
  { name: 'Navarra', code: 'NA' },
  { name: 'Asturias', code: 'O' },
  { name: 'Orense', code: 'OR' },
  { name: 'Palencia', code: 'P' },
  { name: 'Baleares', code: 'PM' },
  { name: 'Pontevedra', code: 'PO' },
  { name: 'Cantabria', code: 'S' },
  { name: 'Salamanca', code: 'SA' },
  { name: 'Sevilla', code: 'SE' },
  { name: 'Segovia', code: 'SG' },
  { name: 'Soria', code: 'SO' },
  { name: 'Guipúzcoa', code: 'SS' },
  { name: 'Tarragona', code: 'T' },
  { name: 'Teruel', code: 'TE' },
  { name: 'Santa Cruz de Tenerife', code: 'TF' },
  { name: 'Toledo', code: 'TO' },
  { name: 'Valencia', code: 'V' },
  { name: 'Valladolid', code: 'VA' },
  { name: 'Álava', code: 'VI' },
  { name: 'Zaragoza', code: 'Z' },
  { name: 'Zamora', code: 'ZA' }
];
